import type { SubmissionStatus } from '../types'
import { statusLabel } from '../lib/utils'

export function StatusBadge({ status }: { status: SubmissionStatus }) {
  return <span className={`status status-${status}`}>{statusLabel(status)}</span>
}
